// Maps the backend's error codes to the i18n keys shown to staff. Shared by
// the preview tray (upload-time failures) and the message bubbles (send-time
// failures), so one code never gets two different wordings.
//
// `error_reason` values come from the send-images response items; the upload
// kinds come from the tray's own client-side checks. An unrecognized code
// falls back to a generic retry message rather than leaking a raw provider
// string into the UI, with the detail kept for the title attribute.
const SEND_ERROR_KEYS = {
  media_too_large: 'inbox.batchError.tooLarge',
  media_unreachable: 'inbox.batchError.unreachable',
  provider_rejected: 'inbox.batchError.providerRejected',
  outside_messaging_window: 'inbox.batchError.outsideWindow',
  user_not_following: 'inbox.batchError.notFollowing',
  channel_unsupported: 'inbox.batchError.channelUnsupported',
  logging_failed: 'inbox.batchError.loggingFailed',
}

const UPLOAD_ERROR_KEYS = {
  too_large: 'inbox.batchError.tooLargeUpload',
  upload_failed: 'inbox.batchError.uploadFailed',
  invalid_type: 'inbox.batchError.invalidType',
}

export function sendErrorKey(code) {
  return SEND_ERROR_KEYS[code] || 'inbox.batchError.generic'
}

export function uploadErrorKey(kind) {
  return UPLOAD_ERROR_KEYS[kind] || 'inbox.batchError.generic'
}
